// Payment rails — server is the source of truth, this is UI catalog only
import { api, formatApiErrorDetail } from "./api";

export const RAILS = [
  {
    id: "stripe",
    label: "Cards · Bank Debit · Cash App · Klarna · Google/Apple Pay",
    short: "Fiat & Wallets",
    description:
      "Visa · Mastercard · Amex · Discover · ACH bank debit · Cash App Pay · Klarna · Apple Pay · Google Pay · Stripe Link.",
    methods: ["VISA", "MC", "AMEX", "ACH", "CASHAPP", "KLARNA", "APPLE", "GOOGLE"],
    icon: "card",
  },
  {
    id: "stripe_crypto",
    label: "USDC Stablecoin",
    short: "Stablecoin Pay",
    description:
      "Settle in USDC via Stripe's regulated crypto rail — instant on-chain confirmation, no volatility.",
    methods: ["USDC"],
    icon: "stable",
  },
  {
    id: "web3_wallet",
    label: "NFT · WalletConnect · Web3.0",
    short: "DeFi / NFT",
    description:
      "Pay with an NFT transfer, a Web3 wallet signature, or a direct on-chain transfer from MetaMask, Phantom, Trust, or any WalletConnect-compatible wallet.",
    methods: ["NFT", "META", "WC", "PHTM"],
    icon: "wallet",
  },
];

// Map flows → server-side package_id keys
export const PACKAGE_FOR_FRANCHISE = {
  starter: { upfront: "franchise_starter", installments: "franchise_starter", "n/a": "franchise_starter" },
  grow_rich: {
    upfront: "franchise_grow_rich_upfront",
    installments: "franchise_grow_rich_installment",
    "n/a": "franchise_grow_rich_list",
  },
  enterprise: { upfront: "franchise_enterprise", installments: "franchise_enterprise", "n/a": "franchise_enterprise" },
};

export const PACKAGE_FOR_FUNDING = {
  ai_report: "funding_ai_report",
  pro_monthly: "funding_pro_monthly",
  pro_annual: "funding_pro_annual",
  autopilot: "funding_autopilot",
};

export async function startStripeCheckout({ package_id, rail = "stripe", metadata = {}, success_path = null, cancel_path = null }) {
  const origin_url = window.location.origin;
  const { data } = await api.post("/payments/checkout/session", {
    package_id,
    rail,
    origin_url,
    metadata,
    success_path,
    cancel_path,
  });
  if (!data?.url) throw new Error("No checkout URL returned");
  window.location.href = data.url;
}

export async function submitWeb3Intent(payload) {
  const { data } = await api.post("/payments/web3/intent", payload);
  return data;
}

export { formatApiErrorDetail };
